import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon, XIcon } from 'lucide-react';
import { hero } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="relative isolate w-full overflow-hidden bg-ink" data-id="element-79" data-mp="9ll8gva8vumg">
      <img src={hero.image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-right" data-id="element-80" data-mp="4mi4zf9wxwgl" />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(10,10,11,0.97)_0%,rgba(10,10,11,0.92)_38%,rgba(10,10,11,0.45)_70%,rgba(10,10,11,0.25)_100%)]" aria-hidden="true" data-id="element-81" data-mp="xae9351taqne" />

      <div className="relative mx-auto flex min-h-[760px] max-w-shell flex-col justify-center px-5 pb-20 pt-32 lg:min-h-[860px] lg:px-8 lg:pt-36" data-id="element-82" data-mp="nc85mj0cxcgf">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="max-w-2xl" data-id="element-83" data-mp="3d2bmnxfzddz8">
          <h1 className="display text-[clamp(2.6rem,6.2vw,4.6rem)] leading-[0.94] text-cream" data-id="element-84" data-mp="3j9ty8ric7ai4">
            {hero.headlineLine1}
            <br data-id="element-85" data-mp="3o5j1b4tkf9j6" />
            {hero.headlineLine2}
          </h1>

          <p className="mt-7 max-w-xl text-lg leading-relaxed text-cream/75" data-id="element-86" data-mp="399jnrenosh6n">{hero.subhead}</p>

          <ul className="mt-8 space-y-3" data-id="element-87" data-mp="3e84nze2xv0v3">
            {hero.missing.map((item, i) => <motion.li key={item.rest} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.24,
            ease: EASE,
            delay: 0.1 + i * 0.045
          }} className="flex items-start gap-3 text-[15px] text-cream/90 md:text-base" data-id="element-88" data-mp="30gzuyuu2t6tq" data-mpi={i}>
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-red" aria-hidden="true" data-id="element-89" data-mp="2vgu25bc2lea2" />
                <span data-id="element-90" data-mp="2hl9sl6i8e8fb">
                  <span className="underline-red font-bold text-cream" data-id="element-91" data-mp="2lkqwhvi0exid">{item.strong}</span>{' '}
                  {item.rest}
                </span>
              </motion.li>)}
          </ul>

          <p className="display mt-10 text-[clamp(1.35rem,2.6vw,1.85rem)] leading-tight text-cream" data-id="element-92" data-mp="nbl42pi3sock">
            <span className="text-brand-green" data-id="element-93" data-mp="ibypocqjh226">Yes!</span> {hero.yesLine}
          </p>
          <p className="display mt-1 text-[clamp(1.05rem,2vw,1.4rem)] text-brand-green" data-id="element-94" data-mp="dd5cklf5zd2j">
            {hero.yesSub}
          </p>

          <div className="mt-9" data-id="element-95" data-mp="1b15ntam2zpmw">
            <a href="#tools" className="group inline-flex items-center gap-3 rounded-md bg-brand-green px-7 py-5 text-base font-semibold text-ink transition-colors duration-150 ease-out hover:bg-brand-greenDark hover:text-white" data-id="element-96" data-mp="1b0dts484tzyq">
              <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-97" data-mp="x02zssbj059c" />
              {hero.ctaLabel}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-98" data-mp="3lt73mli5bhrm" />
            </a>
            <p className="mt-3 text-sm text-cream/55" data-id="element-99" data-mp="1xacfj35u5jt8">
              Click <span className="font-semibold text-cream/85" data-id="element-100" data-mp="21awca5mhyleu">{hero.ctaLabel}</span> {hero.ctaNote}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}